import { render, staticRenderFns } from "./KartOzelindeHesapAyarForm.vue?vue&type=template&id=4ab6043e"
import script from "./KartOzelindeHesapAyarForm.vue?vue&type=script&lang=ts"
export * from "./KartOzelindeHesapAyarForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports